module.exports = {"domain":"nowyu.eu.auth0.com","clientId":"bwYfaa6k4S6yGZMpLI0ffl0VlED0I44w","callbackUrl":"https://we.nowyu.com/login/callback","audience":"api.nowyu.com","responseType":"token id_token","scope":"openid email profile"}


//////////////////
// WEBPACK FOOTER
// ./src/store/auth0.json
// module id = 348
// module chunks = 2